import { makeAutoObservable } from 'mobx'
import {
  AdvancedSchedulingStore,
  type IInitAdvancedScheduling,
} from 'shared/ui/Schedule/ui/AdvancedScheduling'
import { type IInitSendingHours, SendingHoursStore } from 'shared/ui/Schedule/ui/SendingHours'

export type IInitImmediatelyStoreProps = {
  isUseContactTimezone: boolean
  advancedDate?: IInitAdvancedScheduling
  sendingHoursDate?: IInitSendingHours
}

export class ImmediatelyStore {
  constructor() {
    makeAutoObservable(this)
  }

  dropdownId = ''

  handleSendingHoursCallBack = (status: boolean) => {
    this.advancedSchedulingStore?.setAdvancedScheduleDisabled(status)
  }

  handleAdvancedSchedulingCallBack = (status: boolean) => {
    this.sendingHoursStore?.setSendingHoursDisabled(status)
  }

  private _advancedSchedulingStore = new AdvancedSchedulingStore(
    this.handleAdvancedSchedulingCallBack
  )
  private _sendingHoursStore = new SendingHoursStore(this.handleSendingHoursCallBack)

  isUseContactTimezone = false

  init = ({ isUseContactTimezone, advancedDate, sendingHoursDate }: IInitImmediatelyStoreProps) => {
    this.isUseContactTimezone = isUseContactTimezone
    if (advancedDate) {
      this.advancedSchedulingStore.init(advancedDate)
      this.sendingHoursStore?.setSendingHoursDisabled(advancedDate.isAdvancedScheduling)
    }
    if (sendingHoursDate) {
      this.sendingHoursStore.init(sendingHoursDate)
      this.advancedSchedulingStore?.setAdvancedScheduleDisabled(sendingHoursDate.isSendingHours)
    }
    if (sendingHoursDate) {
      this.sendingHoursStore.init(sendingHoursDate)
    }
  }

  toggleUseContactTimezone = () => {
    this.isUseContactTimezone = !this.isUseContactTimezone
  }

  setDropdownId = (dropdownId: string) => {
    this.dropdownId = dropdownId
    this.advancedSchedulingStore.setDropdownId(dropdownId)
    this.sendingHoursStore.setDropdownId(dropdownId)
  }

  get sendingHoursStore() {
    return this._sendingHoursStore
  }

  get advancedSchedulingStore() {
    return this._advancedSchedulingStore
  }

  get isSendingHoursEnabled() {
    return this.sendingHoursStore.isEnabled
  }
}
